import { Alert, Section, Wrapper } from '@ahmdigital/ui';
import { isPlainObject } from 'lodash/fp';
import apiToAlert from '@ahmdigital/logic/lib/utils/api-to-alert';

import styles from './styles.module.sass';
import type { LoadingError as LoadingErrorType } from './types';

type LoadingErrorAlertProps = {
  loadingError: LoadingErrorType;
};

// @ts-expect-error - Automatic, Please fix when editing this file
const shouldShowLoadingErrorAlert = (loadingError) => isPlainObject(loadingError);

const LoadingErrorAlert = ({ loadingError }: LoadingErrorAlertProps) => (
  <div className={styles.section}>
    <Section>
      <Wrapper size="large">
        <Alert {...apiToAlert(loadingError)} />
      </Wrapper>
    </Section>
  </div>
);

export default LoadingErrorAlert;

export { shouldShowLoadingErrorAlert };
